import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TemplateReplacePipe} from "./template-replace.pipe";

@NgModule({
  imports: [CommonModule, TemplateReplacePipe],
  declarations: [],
  exports: [TemplateReplacePipe],
})

export class TemplateReplaceModule {}
